import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

/**
 * Temporary placeholder component for Category Management
 * The TreeView implementation will be added later
 */
const CategoryManagement = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Category Management
      </Typography>
      
      <Paper elevation={2} sx={{ p: 3, mt: 2, backgroundColor: '#f5f5f5' }}>
        <Typography variant="h6" gutterBottom>
          This feature is currently under development
        </Typography>
        <Typography paragraph>
          The category management functionality has been temporarily removed and will be implemented 
          in a future update. Please check back later.
        </Typography>
        
        <Button 
          variant="contained" 
          color="primary"
          disabled
          sx={{ mt: 2 }}
        >
          Add Category (Coming Soon)
        </Button>
      </Paper>
    </Box>
  );
};

export default CategoryManagement;